import Template from '../../component/Template.js';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React  from "react";
import { useNavigate,useParams } from 'react-router-dom';

import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';

export default function FacultyEdit() {
const [faculty, setFacultyData] = useState({});
const [message, setMessage] = useState("");

const [errors, setErrors] = useState({ fcode: '', fname: '',fstaus: ''}); 
const { http } = Api();


let { id } = useParams();
const decodedID = atob(id);
sessionStorage.setItem("id", decodedID);

const navigate = useNavigate();

//seting up current value for each fields
useEffect(() => {
    const { http } = Api();
    const id1 = sessionStorage.getItem("id");
    const fetchData = async () => {
        try {

            const response = await http.get(`/Admin/getfaculty/${id1}`);
            setFacultyData(response.data.faculty);

        } catch (error) {

            setMessage("somthing went wrong");
            console.error('Error fetching faculty data:', error);

        }
    };

    fetchData();

}, []);


const isAuth = useAuth();
if (isAuth === false) {
     navigate("/admin/")
}

const validateForm = () => {

    const updatedErrors = {};
    let hasError = false;

    const status = document.getElementById('status').value;
    const facultyname1 = document.getElementById('facultyname').value;
    const facultycode1 = document.getElementById('facultycode').value;

    if (!facultycode1) {

      updatedErrors.fcode = 'Please enter a faculty code';
      hasError = true;     

    }
    if (!facultyname1) {

      updatedErrors.fname = 'Please enter a faculty name';
      hasError = true;   

    }
    if (status === "0") {
      updatedErrors.fstaus = 'Please select a Status';
      hasError = true; 

    }
    if (hasError) 
    {
      setErrors(updatedErrors);
      if (!facultyname1) {
          document.getElementById('facultyname').focus();
      } else if (!facultycode1) {
          document.getElementById('facultycode').focus();
      } else if (status === "0") {
        document.getElementById('status').focus();
      }
      return false;
   } else {
      setErrors({ fcode: '', fname: '',fstaus: ''});
      return true;
   }

   
};

const cancelForm = () => {
    navigate("/admin/faculty");
    sessionStorage.removeItem("message", "Faculty updated successfully");
};

const saveForm = () => {


    if (validateForm()) {

        const id2 = sessionStorage.getItem("id");



        const facultyname1 = document.getElementById('facultyname').value;
        const facultycode1 = document.getElementById('facultycode').value;
        const remarks = document.getElementById('remarks').value;
        const status = document.getElementById('status').value;
        



        const remarksValue = remarks ? remarks : "Null";
        http.post(`/Admin/updatefaculty/${id2}`, { faculty_name: facultyname1, faculty_code: facultycode1, remarks: remarksValue, status: status })
            .then(response => {

                if (response.data.status_code === "MSG2") {
                    sessionStorage.setItem("message", "Faculty updated successfully");
                    navigate("/admin/faculty");

                }
            })
            .catch(error => {
                console.error(error);


                if (error.response && error.response.status === 500) {
                    setMessage("Duplicate Value: This faculty already exists");
                } else {
                    setMessage("Something Went Wrong");
                }

            });
    }
};


  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12" >
              <div className="card">                
                <div className="col-md-12">
                  <div className="card-header"> 
                    <div className="py-3 d-flex justify-content-between align-items-center ">
                      <h5>Edit Faculty</h5>
                    </div>
                  </div>
                  <div className="card-body">
                  {message && (
                                                <div className="alert alert-danger mar2" role="alert">
                                                    <p style={{ textAlign: 'center', textJustify: 'auto' }}>{message}</p>
                                                </div>
                                            )}
                    <div className="card-body pdg">
                      <div className="table-responsive">


                        <div className="form theme-form">
                          <div className="card-body custom-input">
                            <div className="row">
                              <div className="col">
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Faculty Code <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="facultycode" name="facultycode" defaultValue={faculty.faculty_code} required maxLength={3} placeholder="Faculty Code" />
                                    {errors.fcode && <p className="text-danger">{errors.fcode}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Faculty Name <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <input className="form-control input-air-primary" type="text" id="facultyname" name="facultyname" defaultValue={faculty.faculty_name} placeholder="Faculty Name" />
                                    {errors.fname && <p className="text-danger">{errors.fname}</p>}
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Remarks</label>
                                  <div className="col-sm-9">
                                    <textarea className="form-control input-air-primary" id="remarks" name="remarks" placeholder="Remarks" defaultValue={faculty.remarks === 'Null' ? '' : faculty.remarks}/> 
                                  </div>
                                </div>
                                <div className="mb-3 row">
                                  <label className="col-sm-3">Status <span className="errorclr">*</span></label>
                                  <div className="col-sm-9">
                                    <select className="form-control input-air-primary" id="status" name="status" required defaultValue={faculty.status}>
                                        <option value="0">---Select---</option>
                                        <option value="active" selected={faculty.status === 'active' ? 'selected' : null}>Active</option>
                                        <option value="inactive" selected={faculty.status === 'inactive' ? 'selected' : null}>Inactive</option>
                                    </select>
                                  {errors.fstaus && <p className="text-danger">{errors.fstaus}</p>}
                                </div>
                            </div>

                              </div>
                            </div>
                          </div>
                          
                            <div className="col-md-12 txt-aln">
                              <button className="btn btn-primary me-3" type="submit" onClick={saveForm}>Submit</button>
                              <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                            </div>
                          
                        </div>



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}
